import Cookies from 'js-cookie'

import isEmpty from 'lodash/isEmpty'
import encryption from './encryption'

let cache = {}

const secureCookies = {
  getItem: key => {
    if (cache[key] !== undefined) return cache[key]

    const data = Cookies.get(encryption.encryptWithMD5(key))

    let state
    if (!isEmpty(data)) {
      const result = encryption.decryptWithAES(data)
      try {
        state = JSON.parse(result)
      } catch (error) {
        state = result
      }

      cache[key] = state
      return state
    }

    return undefined
  },
  setItem: (key, value, options) => {
    cache[key] = value
    Cookies.set(
      encryption.encryptWithMD5(key),
      encryption.encryptWithAES(value),
      options,
    )
  },
  removeItem: key => {
    delete cache[key]
    Cookies.remove(encryption.encryptWithMD5(key))
  },
  clearItem: () => {
    cache = {}
    document.cookie.split('; ').forEach(cookie => {
      const eqPos = cookie.indexOf('=')
      const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie
      document.cookie = `${name}=; Max-Age=0; Secure; SameSite=None; path=/;`
    })
  },
}

export default secureCookies
